import * as React from 'react'
import { SVGProps } from 'react'

const SvgUnlink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M17.819 1.135a.675.675 0 0 0-.954-.954l-1.811 1.811a3.826 3.826 0 0 0-4.917.416l-.96.962a1.575 1.575 0 0 0 0 2.226l3.226 3.228a1.575 1.575 0 0 0 2.227 0l.961-.961a3.825 3.825 0 0 0 .417-4.917l1.81-1.81Zm-3.227 2.228.02.02.003.002.002.003.02.02a2.473 2.473 0 0 1 0 3.5l-.96.961a.225.225 0 0 1-.32 0L10.13 4.642a.227.227 0 0 1-.049-.245.227.227 0 0 1 .05-.073l.96-.961a2.476 2.476 0 0 1 3.501 0ZM7.92 8.335a.675.675 0 1 0-.954-.954L5.417 8.93l-.423-.423a.675.675 0 0 0-.954 0l-1.598 1.598a3.826 3.826 0 0 0-.416 4.916L.215 16.831a.675.675 0 1 0 .954.954l1.81-1.81a3.826 3.826 0 0 0 4.917-.417l1.598-1.598a.675.675 0 0 0 0-.954l-.423-.423 1.548-1.548a.674.674 0 1 0-.954-.954L8.117 11.63 6.37 9.883l1.548-1.548Zm-2.983 2.022.004.003.003.004 2.693 2.693.004.003.003.004.419.42-1.12 1.12a2.477 2.477 0 0 1-3.5 0l-.046-.045a2.476 2.476 0 0 1 0-3.501l1.12-1.119.42.42v-.002Z"
      fill="currentColor"
    />
  </svg>
)

export default SvgUnlink
